export const FREE_REPORT_GATE_MESSAGE =
  "Free Investor plan cannot generate reports. Upgrade to Starter or Pro to create and download PDF reports.";

export const PRO_BRANDING_UPGRADE_MESSAGE =
  "Branding settings require the Pro Investor plan. Upgrade to Pro to customize report branding.";

export const normalizeTier = (tier) => {
  const normalized = String(tier || "free").trim().toLowerCase();
  if (normalized === "light") return "free";
  if (normalized.startsWith("free")) return "free";
  if (normalized.startsWith("starter")) return "starter";
  if (normalized.startsWith("pro")) return "pro";
  if (normalized.startsWith("developer")) return "developer";
  return normalized || "free";
};

export const isFreeTier = (tier) => normalizeTier(tier) === "free";

export const hasProAccess = (tier) => {
  const normalizedTier = normalizeTier(tier);
  return normalizedTier === "pro" || normalizedTier === "developer";
};

export const hasPaidFeatureAccess = (tier) => {
  const normalizedTier = normalizeTier(tier);
  return ["starter", "pro", "developer"].includes(normalizedTier);
};

export const paidFeatureMessage = (featureName) =>
  `${featureName} requires Starter or Pro. Upgrade to access this feature.`;

export const proFeatureMessage = (featureName) =>
  `${featureName} requires Pro. Upgrade to access this feature.`;
